import { ProfileData } from "../../../../../contexts/phone/Phone.types";
import styles from "./PhoneLayers.module.scss";
import { ViewCount } from "./ViewCount.component";

export const Profile = ({ profileData }: { profileData: ProfileData }) => {
  return (
    <div className={styles.profileWrapper}>
      <div className={styles.left}>
        <div className={styles.name}>
          <img src={profileData.profilePic} alt={profileData.name} />
          <div className={styles.nameText}>
            <p>{profileData.name}</p>
            <ViewCount />
          </div>
        </div>
      </div>

      <img src="/logo_triller.png" alt="" className={styles.trillerLogo} />
    </div>
  );
};
